<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='tableParams'
      methods-data='get_feedback'
      params>
      <div>
        <!--        <span class="left-table">昵称：</span>-->
        <!--        <el-input v-model="work_group_name" placeholder="请输入站点名称" style="width: 200px;"></el-input>-->
        <!--        <span class="left-table">-->
        <!--          <el-button type="primary" icon="el-icon-search" @click="find">查找</el-button>-->
        <!--        </span>-->
        <!--        <span class="left-table">-->
        <!--          <el-button type="success" icon="el-icon-circle-plus" @click="showAdd">增加</el-button>-->
        <!--        </span>-->
      </div>

    </icare-table>
    <!--    &lt;!&ndash; 编辑信息 &ndash;&gt;-->
    <!--    <el-dialog title='编辑信息' :visible.sync='editVisible' width='50%'>-->
    <!--      <el-form :model='form' label-width='200px'>-->

    <!--        &lt;!&ndash;        <el-form-item :disabled='true' label="代理商ID" :label-width="formLabelWidth">&ndash;&gt;-->
    <!--        &lt;!&ndash;          <el-input v-model="form.agency_id" disabled  placeholder="请输入代理商ID"></el-input>&ndash;&gt;-->
    <!--        &lt;!&ndash;        </el-form-item>&ndash;&gt;-->

    <!--        <el-form-item label='站点名称' :label-width='formLabelWidth'>-->
    <!--          <el-input v-model='form.work_group_name'></el-input>-->
    <!--        </el-form-item>-->

    <!--        <el-form-item label='收费类型' :label-width='formLabelWidth'>-->
    <!--          <el-select v-model='form.charge_type_id' placeholder='请选择'>-->
    <!--            <el-option-->
    <!--              v-for='item in time_standard_options'-->
    <!--              :key='item.id'-->
    <!--              :label='item.time_standard_name'-->
    <!--              :value='item.id'>-->
    <!--            </el-option>-->
    <!--          </el-select>-->

    <!--        </el-form-item>-->

    <!--        <el-form-item label='基础电费' :label-width='formLabelWidth'>-->
    <!--          <el-input-number v-model='form.base_energy_charge' precision='2' controls-position='right' :min='1'-->
    <!--                           :max='10'></el-input-number>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->
    <!--      <div slot='footer' class='dialog-footer'>-->
    <!--        <el-button @click='closeDialog'>取 消</el-button>-->
    <!--        <el-button type='primary' @click='save'>确 定</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'
import { getCookie } from '@/utils/auth'

export default {
  data() {
    return {
      loading: false,
      tableParams: {
        id: null
      },
      titleConfig: [
        {
          field: 'id',
          title: '流水号',
          visible: false
        },

        {
          field: 'user_id',
          title: '用户ID',
          visible: false
        },
        {
          field: 'phone',
          title: '客户手机',
          visible: true
        },
        {
          field: 'type',
          title: '内容类型',
          visible: true,
          fuc: val => {
            let v
            if (val == 'COMPLAIN') {
              v = '<div style="color:#67C23A">订单投诉</div>'
            } else {
              v = '<div style="color:#409EFF">反馈留言</div>'
            }
            return v
          }
        },
        {
          field: 'order_id',
          title: '订单号',
          visible: true,
          fuc: val => {
            return (val === null || val === undefined || val == 'null' || val == 'undefined') ? '-' : val
          }
        },
        {
          field: 'title',
          title: '标题',
          visible: true
        },
        {
          field: 'content',
          title: '内容详情',
          visible: true
        },
        {
          field: 'dispose',
          title: '是否处理',
          visible: true,
          fuc: val => {
            let v
            if (val == 'FINISH') {
              v = '<div style="color:#67C23A">已处理</div>'
            } else {
              v = '<div style="color:#F56C6C">未处理</div>'
            }
            return v
          }
        },
        {
          field: 'create_time',
          title: '创建时间',
          visible: true
        },
        {
          title: '操作',
          width: 60,
          align: 'right',
          option: true,
          children: [
            {
              title: '标识处理',
              color: '#F56C6C',
              icon: 'el-icon-edit-outline',
              fuc: this.disposeFeedback
            },
            // {
            //   title: '查看充电记录',
            //   icon: 'el-icon-document',
            //   fuc: val => {
            //     if (val.order_id === null || val.order_id === undefined || val.order_id == 'null' || val.order_id == 'undefined') {
            //       return
            //     }
            //     this.$router.push({
            //       path: '/order',
            //       query: { order_id: val.order_id }
            //     })
            //   }
            // }
          ]
        }
      ],
      form: {
        id: ''
      },
      formLabelWidth: '100px',
      editVisible: false,
      dialogType: 0
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {

  },
  methods: {
    //弹出编辑(新增)对话框
    showAdd() {
      this.dialogType = 1
      this.editVisible = true
      this.form = Object.assign({ id: 0, agency_id: parseInt(getCookie('agency_id')), base_energy_charge: 0.0 })
    },
    //弹出编辑(新增)对话框
    showEdit(row) {
      this.dialogType = 2
      this.editVisible = true
      this.form = Object.assign({}, row)
    },
    //关闭编辑对话框
    closeDialog() {
      this.editVisible = false
      this.dialogType = 0
      this.form = {}
    },
    //模糊搜索
    find() {
      this.tableParams.work_group_name = this.work_group_name
    },
    //删除某条记录
    delete(row) {
      this.$confirm('是否要删除：' + row.work_group_name + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'del_workgroup',
          params: str
        }).then(() => {
          this.$refs.table.refresh()
        })
      }).catch(() => {
      })
    },

    disposeFeedback(row) {
      this.$confirm('此操作将标识已处理， 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let str = JSON.stringify({
          order_id: row.id
        })

        gateway({
          func: 'set_feedback_dispose',
          params: str
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error('操作失败：'+res.msg)
          }
        })
      }).catch(() => {

      })
    }

  }
}
</script>
<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}

</style>
